import { type AnimationSequence, animate, inView, stagger } from "motion";
import { splitText } from "motion-plus";

inView(".hero", (element) => {
	const animationSequence: AnimationSequence = [];

	const titleElement = element.querySelector("h1");
	const subTitleElement = element.querySelector(".hero-subtitle");
	const buttonElements = element.querySelectorAll("a.button");

	if (titleElement) {
		const staggerElements: Element[] = [];

		titleElement.querySelectorAll("span").forEach((span) => {
			staggerElements.push(...splitText(span).words);
		});
		animationSequence.push([staggerElements, { translateX: [-4, 0], translateY: [10, 0], opacity: [0, 1] }, { delay: stagger(0.1) }]);
	}

	if (subTitleElement) {
		animationSequence.push([subTitleElement, { translateX: [-4, 0], translateY: [10, 0], opacity: [0, 1] }, { delay: stagger(0.1) }]);
	}

	if (buttonElements.length > 0) {
		animationSequence.push([buttonElements, { translateX: [-4, 0], translateY: [10, 0], opacity: [0, 1] }, { delay: stagger(0.1) }]);
	}

	animate(animationSequence);
});
